<template>
  <div class="tabs-view-tab">
    <router-link class="tab" :to="to" :exact="true" :aria-current="current ? 'page' : null">
        <span class="label" v-text="label"></span>
    </router-link>
  </div>
</template>

<script>

export default {
  name: "tabs-view-tab",
  props: ["label", "to", "current"],
};
</script>
<style scoped>

.tabs-view-tab{
  display: flex;
}
.tab {
  margin: 0 0.1rem;
  position: relative;
  display: flex;
  padding: 0.5rem 0.5rem 0.6rem;
  align-items: center;
  color: var(--dark-gray);
  color: #444;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 300;
  line-height: 1.4rem;
  text-transform: capitalize;
}

.tabs-view-tab.active .tab a,
.tabs-view-tab:not(.parent) .tab.router-link-active a{
  color: var(--ion-color-primary);
  font-weight: 400;
}
/* The active underline is now a single sliding indicator owned by TabsView (see .tabs-indicator). */

/* visible focus indicator for keyboard navigation */
.tab:focus-visible {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: -2px;
  border-radius: 4px;
}

@media (max-width: 600px) {
  .tab a {
    padding: 0.5rem 0.5rem 0.5rem;
    font-size: 0.8rem;
  }
}
@media (max-width: 600px) {
  .tab a {
    padding: 0.5rem 0.25rem 0.5rem;
    font-size: 0.87rem;
  }
}

</style>